import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

const activeCardStyles = css`
  width: 396px;
  height: 266px;
  border-color: #b9d3ff;
  border-radius: 14.4px;
  padding: 9.6px 19.2px 14.4px;
  background-image: linear-gradient(
    213.77deg,
    rgb(237, 243, 252) 40.95%,
    rgb(244, 234, 243) 91.01%
  );
  background-color: transparent;
`;

const inactiveCardStyles = css`
  width: 202px;
  height: 106px;
  border-color: #6e9aec;
  border-radius: 9.6px;
  padding: 14.4px;
  background-color: #f0f6ff;
  background-image: none;
  cursor: pointer;
`;

export const Card = styled(motion.div)<{ $active?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  border-style: solid;
  border-width: 1px;
  box-shadow:
    0px 4px 20px 2px rgba(89, 98, 112, 0.1),
    0px 2px 6px 0px rgba(89, 98, 112, 0.15);
  transition:
    background-color 0.4s ease,
    background-image 0.4s ease,
    border-color 0.4s ease,
    border-radius 0.4s ease;
  ${({ $active }) => ($active ? activeCardStyles : inactiveCardStyles)}
`;

export const Body = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const ActiveBody = styled(Body)`
  gap: 4.8px;
  align-items: stretch;
`;

export const InactiveBody = styled(Body)`
  gap: 9.6px;
`;

export const InactiveIconWrap = styled.div`
  width: 38.4px;
  height: 38.4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1656cf;
  flex-shrink: 0;
`;

export const InactiveLabel = styled.span`
  ${typographyMixin("body", 4)}
  color: ${rawColors.text.highEmphasis};
  text-align: center;
  white-space: nowrap;
`;

export const ActiveHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4.8px;
  width: 100%;
`;

export const ActiveLogo = styled.img`
  width: 16.8px;
  height: 16.8px;
  flex-shrink: 0;
`;

export const ActiveTitle = styled.span`
  ${typographyMixin("subtitle", 2)}
  color: ${rawColors.text.highEmphasis};
  white-space: nowrap;
`;
